namespace('compass.tiles');

compass.tiles.RegisterTileWidget = compass.defineWidget(function RegisterTileWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;

	function cleanRegUrl(regURL) {
		return regURL.replace(new RegExp("&amp;", "g"), '&');
	}

	var registrationURL = cleanRegUrl(_settings.regURL);

	var drawRegLink = function(regURL,target) {
		return d.a({href:regURL, target:target}, 'Visit event registration for this show.').click(function(){
			me.trigger('RegisterTileWidget.regLinkClicked');
		});
	};

	var drawShowLink = function(showUrl,target){
		return d.a({href:showUrl, target:target}, 'event website').click(function(){
			me.trigger('RegisterTileWidget.regErrorLinkClicked');
		});
	};

	this.render = function(widgetElem) {
		//compass.loading.start() should be called for this in the view so it doesn't interfere with the view loading spinners
		var loadingSpinner = d.div({className: 'loadingSpinner'});
		var _smallTypeCopy = _settings.asyncLoad ? loadingSpinner : drawRegLink(registrationURL,'_blank');

		widgetElem.append(d.div({
			className : 'smallTile tile'
		},
			d.div({ className : 'smallTileHeader' },
				d.h3({ className : 'headerCopy' }, 'Registration'),
				d.div({ className : 'endHeader' })
			),
			d.div({ className : 'smallTileCopy'},
				_smallTypeCopy
			)
		));
	};

	me.asyncLoad = function(data) {
		registrationURL = cleanRegUrl(data.regURL);
		me.find('.smallTileCopy').empty().append(drawRegLink(registrationURL,data.target));
	};

	me.displayShowLink = function(showUrl,target){
		var smallTileCopy = me.find('.smallTileCopy');
		smallTileCopy.empty();
		smallTileCopy.append('To access registration please visit the ');
		smallTileCopy.append(drawShowLink(showUrl,target));
		smallTileCopy.append('.');
	};

	var d = $j.dom.getContext(this);
}, {
	GUID : 'defaultRegisterTileWidgetGUID',
	widgetName : 'RegisterTileWidget',
	regURL : '',
	asyncLoad : false
});

